export class AsyncMutex {
    constructor() {
        this.queue = [];
        this.locked = false;
    }
    async acquire(signal) {
        signal?.throwIfAborted();
        if (!this.locked) {
            this.locked = true;
            return this.createRelease();
        }
        return new Promise((resolve, reject) => {
            const onAbort = () => {
                const idx = this.queue.indexOf(waiter);
                if (idx !== -1)
                    this.queue.splice(idx, 1);
                reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            };
            const waiter = () => {
                signal?.removeEventListener('abort', onAbort);
                resolve(this.createRelease());
            };
            signal?.addEventListener('abort', onAbort, { once: true });
            this.queue.push(waiter);
        });
    }
    createRelease() {
        let released = false;
        return () => {
            if (released)
                return;
            released = true;
            const next = this.queue.shift();
            if (next) {
                next();
            }
            else {
                this.locked = false;
            }
        };
    }
    get isLocked() {
        return this.locked;
    }
}
